module.exports = __webpack_public_path__ + "img/schedule.b6960364.svg";